<template>
  <div class="express-info">
    <el-dialog
      title="上传发票单号"
      width="540px"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form
        ref="formEl"
        :model="form"
        :rules="rules"
        label-width="120px"
        size="small"
      >
        <el-form-item label="快递单号：" prop="expressNo">
          <el-input :readonly="$myStore.state.user.userIdentity === 2" v-model.trim="form.expressNo" placeholder="请填写快递单号" style="width: 320px" />
        </el-form-item>
        <el-form-item label="上传图片：" prop="expressImg">
          <PictureUpload v-model="expressImg" :limit="9" :isDisabled="$myStore.state.user.userIdentity === 2" />
          <p class="form-tips">支持扩展名: .png .jpeg .jpg 文件大小2M以内</p>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleClose">关 闭</el-button>
        <el-button :loading="saveing" size="small" type="primary" @click="handleAffirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  uploadInvoice
} from "@/api/orderAdmin/orderList"
import PictureUpload from "@/components/pictureUpload.vue"
import { processing } from '@/utils/handle.js'

export default {
  name: 'ExpressInfo',

  components: { PictureUpload, },
  data () {
    return {
      dialogVisible: false,
      form: {
        expressNo: '',
        expressImg: ''
      },
      expressImg: [],
      rules: {
        expressNo: [
          { required: true, message: "请填写快递单号!", trigger: "blur" },
        ],
        expressImg: [
          { required: true, message: "请上传图片!", trigger: "blur" },
        ],
      },
      saveing: false
    }
  },
  methods: {
    init (payload) {
      this.form.id = payload.id
      if (payload.expressImg) {
        const t = payload.expressImg.split(',')
        this.expressImg = t.map(url => {
          return { url }
        })
      }
      this.form.expressNo = payload.expressNo
      this.dialogVisible = ''
    },
    handleAffirm () {
      this.$refs.formEl.validate(valid => {
        if (valid) {
          this.saveing = true
          const params = {
            ...this.form
          }
          uploadInvoice(processing(params)).then(({ code }) => {
            if (code === 0) {
              this.$message.success('上传发票单号成功!')
              this.$emit('refresh')
              this.handleClose()
            }
          }).finally(() => {
            this.saveing = false
          })
        }
      })
    },
    handleClose () {
      this.form = this.$options.data().form
      this.expressImg = []
      this.$refs.formEl && this.$refs.formEl.resetFields()
      this.dialogVisible = false
    }
  },
  watch: {
    expressImg: {
      handler (val) {
        if (val && val.length) {
          const t = val.map(item => item.url)
          this.form.expressImg = t.join(',')
          this.$nextTick(() => {
            this.$refs.formEl.clearValidate('expressImg')
          })
        } else {
          this.form.expressImg = ''
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
.express-info {
  ::v-deep .el-upload--picture-card {
    width: 100px;
    height: 100px;
    line-height: 100px;
    .el-icon-plus {
      line-height: 100px;
    }
  }
  ::v-deep .el-upload-list__item {
    width: 100px;
    height: 100px;
  }
}
.form-tips {
  font-size: 12px;
  color: #999;
}
</style>
